import React from 'react';

import { Button, Bevel } from './styles';

interface Props {
  label: string;
  iconSrc: string;
  onClick: () => void;
}

const ChannelButton = ({ label, iconSrc, onClick }: Props) => (
  <Button onClick={onClick}>
    <Bevel iconSrc={iconSrc} />
    <span>{label}</span>
  </Button>
);

export default ChannelButton;
